<script setup>
  import { ref, onMounted, watch } from 'vue';
  import { useSpotStore } from "@/stores/SpotStore";
  import { useSessionStore } from "@/stores/SessionStore";
  import ModalDownloadArchiveData from '@/components/ModalDownloadArchiveData.vue';
  import useContainerConfigurationGlobals from '@/composables/useContainerConfigurationGlobals';
  import useLegacyBridge from "@/composables/useLegacyBridge";
  import { useUpdateKey } from '@/composables/useUpdateKey';

  defineExpose({ getSettings })

  const content = defineModel('content');

  const props = defineProps({
    containerSettings: {
      type: Object,
      required: false
    },
    isFavorite: {
      type: Boolean,
      default: false
    }
  })

  const spotId = props.isFavorite && props.containerSettings && Object.prototype.hasOwnProperty.call(props.containerSettings, 'spotId')
    ? parseInt(props.containerSettings.spotId)
    : null;    

  const sessionStore = useSessionStore();
  const spotStore = useSpotStore(spotId);

  const { $ARCHIVE_DATA } = useContainerConfigurationGlobals();
  const { archiveData } = useLegacyBridge();
  const updateKey = useUpdateKey()

  if (props.isFavorite && spotId) {
    await spotStore.getSpotDetailById(spotId, { spot_types: "1,100,101" });
  }  

  const contentContainer = ref(null);
  const showModal = ref(false);
  const downloadDataInfo = ref({
    startDate: null,
    endDate: null,
    url: null,
    filename: null,
    type: 'csv'
  });
  
  function loadArchiveData() {
    const settings = {
      spotId: spotStore.spotId,
      displayYesterday: true,
      stationCapabilities: getStationCapabilities(spotStore.spot.stations),
    }

    if ($ARCHIVE_DATA.allow_data_download) {
      
      settings.downloadClicked = (spotId, apiStartDate, apiEndDate, exceptionList, userWindUnits, userTempUnits, fileType) => {
        downloadDataInfo.value.url = `https://api.weatherflow.com/wxengine/rest/spot/getSpotDetail?wf_token=${sessionStore.token}&units_wind=${userWindUnits}&units_temp=${userTempUnits}&format=${fileType}&time_start=${apiStartDate}&time_end=${apiEndDate}&spot_id=${spotId}`;
        downloadDataInfo.value.startDate = apiStartDate;
        downloadDataInfo.value.endDate = apiEndDate;
        downloadDataInfo.value.filename = `obs-${spotId}-${apiStartDate.replace(' ', '')}-${apiEndDate.replace(' ', '')}-data.${fileType}`;   
        showModal.value = true;
      }
    }
    
    content.value = archiveData(contentContainer.value, settings);
  }

  function getStationCapabilities(stations) {
      var stationCapabilites = [];

      stations.forEach(function (station) {
          if (!station.capabilities) return;

          station.capabilities.forEach(function (capability) {
            if (!station.capabilities) return;

            if (stationCapabilites.indexOf(capability) === -1) {
                stationCapabilites.push(capability);
            }
          })
      })

      return stationCapabilites;
  }

  function getSettings() {
    if (content.value) {
      return content.value.getSettings();
    }

    return null;
  }

  onMounted(() => loadArchiveData());

  watch(updateKey.key, () => {
    content.value.refresh();
  })
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div> 

  <ModalDownloadArchiveData
    v-model="showModal"
    :downloadInfo="downloadDataInfo"
  />
</template>